import { toast } from "react-toastify";
import { ERROR_TYPES } from "../context/reducers/errorReducers";
import { DateTime } from "luxon";
import { WEB_URL } from "../config";

export const PAGES = [
  {
    id: "HOME",
    name: "Page d'accueil",
    link: `${WEB_URL}`,
  },
  {
    id: "PJ",
    name: "Page Protection Juridique",
    link: `${WEB_URL}protection-juridique`,
  },
  {
    id: "AC",
    name: "Page Assurance Construction",
    link: `${WEB_URL}assurance-construction`,
  },
  {
    id: "CYBER",
    name: "Page Assurance Cyber",
    link: `${WEB_URL}assurance-cyber`,
  },
  {
    id: "MRP",
    name: "Page Multirisque Professionnelle",
    link: `${WEB_URL}multirisque-professionnelle`,
  },
  {
    id: "RCPRO",
    name: "Page Responsabilité Civile Professionnelle",
    link: `${WEB_URL}responsabilite-civile-pro`,
  },
  {
    id: "FORM",
    name: "Formulaire de souscription",
    link: `${WEB_URL}assurer-mon-entreprise`,
  },
];

// Référentiel de civilité servi par l'API (constante dynamique GENDERS).
// Alimenté une fois au chargement des constantes via tools.setGendersReferential,
// pour que les helpers d'affichage (getGender/getFullName) restent purs tout en
// s'appuyant sur la liste servie par le back plutôt que sur des libellés en dur.
let gendersReferential = [];

const tools = {
  setGendersReferential: (genders) => {
    gendersReferential = Array.isArray(genders) ? genders : [];
  },
  findIn: (inTheArray, theValue, theField) => {
    var returnValue = {};
    if (inTheArray.length && theField) {
      returnValue = inTheArray.find((en) => en[theField] == theValue) || {};
    }
    return returnValue;
  },
  checkEntryDateValid: (date) => {
    if (date && date.length >= 10) {
      if (DateTime.fromISO(date).isValid) {
        return true;
      }
      return false;
    }
  },
  getDateFrom: (date) => {
    return date;
  },
  getDateIso: (date) => {
    return date.length >= 10
      ? DateTime.fromFormat(date, "dd/MM/yyyy").toISO()
      : date;
  },
  formatDate: (date, format = "dd.MM.yyyy") => {
    return date ? DateTime.fromISO(date).toFormat(format) : "";
  },
  formatDateHours: (date) => {
    return DateTime.fromISO(date).toFormat("dd.MM.yy HH:mm");
  },
  formatDateComment: (date) => {
    return DateTime.fromISO(date).toFormat("dd.MM.yy HH:mm");
  },
  getFullAddress: (location) => {
    return location
      ? `
    ${location.address || ""} ${location.address2 || ""} ${
          location.postalCode || ""
        } ${location.city || ""}
    `
      : "";
  },
  formatFollowingPattern: (value = "", separation = [], separator = "") => {
    if (!value) return "";
    var nirconcat = value.split(separator).join("");

    var newnir = "";
    var curr = 0;
    for (var key in separation) {
      var ns = separation[key] + curr;
      if (curr < nirconcat.length) {
        newnir += nirconcat.substring(curr, ns);
        var newnirsp = newnir.split(separator);
        if (
          newnirsp[newnirsp.length - 1].length == separation[key] &&
          newnirsp.length < separation.length
        ) {
          newnir += separator;
        }
      }

      curr = ns;
    }
    if (newnir.substr(newnir.length - separator.length) == separator) {
      newnir = newnir.substring(0, newnir.length - separator.length);
    }
    return newnir;
  },
  formatPhone: (phone) => {
    if (!phone) return "";
    let normalVal = phone.split(".").join("").split(" ").join("");
    return tools.formatFollowingPattern(normalVal, [4, 2, 2, 2], " ");
  },
  formatSIREN: (siren) => {
    if (!siren) return "";
    let normalVal = siren.split(".").join("").split(" ").join("");
    return tools.formatFollowingPattern(normalVal, [3, 3, 3], " ");
  },
  isEmpty: (value) => {
    return (
      value === undefined ||
      value === null ||
      !value ||
      (typeof value === "object" && Object.keys(value).length === 0) ||
      (typeof value === "string" && value.trim().length === 0)
    );
  },

  truncate: (text, n) => {
    return text.length > n ? text.substr(0, n - 1) + "..." : text;
  },

  filterError: (errors, dispatch = null, type) => {
    var errorData = {};
    if (errors.response) {
      var status = errors.response.status;

      if (status == 404) {
        toast.error("La route n'a pas été trouvée");
      }

      if (errors.response.data) {
        if (errors.response.data.other) {
          toast.warning("Erreur : " + errors.response.data.other);
          errorData = errors.response.data;
        } else {
          errorData = errors.response.data;
        }
      }
    } else {
      toast.error("Erreur interne : " + errors);
    }

    if (dispatch) {
      dispatch({ type: type, payload: false });
      dispatch({ type: ERROR_TYPES.GET_ERRORS, payload: errorData });
    }
    return errorData;
  },
  filterAlert: (type, message) => {
    switch (type) {
      case "success":
        toast.success(message);
        break;
      case "info":
        toast.info(message);
        break;

      default:
        break;
    }
  },
  getState: (page, initial) => {
    var ls = localStorage.getItem(page);
    console.log(ls);
    if (ls) {
      return JSON.parse(ls);
    }
    return initial;
  },

  saveState: (page, name, value) => {
    var ls = localStorage.getItem(page);
    if (ls) {
      ls = JSON.parse(ls);
    } else {
      ls = {};
    }
    ls[name] = value;

    localStorage.setItem(page, JSON.stringify(ls));
    console.log(localStorage.getItem(page));
  },
  truenumberWithSpaces: (x) => {
    if (!x) return "";
    x = x == "0" ? "" : x + "";
    x = x.replace(/\s/g, "");
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  },
  isParentRoleActive(roleKey, roleConfig, dependsOn) {
    if (!dependsOn) {
      return true;
    }
    var isActive = true;
    dependsOn.forEach((d) => {
      if (!roleConfig[d][roleKey]) {
        isActive = false;
      }
    });
    return isActive;
  },
  // Libellé de civilité pour un code donné, résolu depuis le référentiel API.
  // Retourne "" si le code est absent, vide ou correspond à « aucune civilité »
  // (code 0, dont le libellé API est vide) : aucun préfixe ne doit alors apparaître.
  getGender: (gender) => {
    if (gender === undefined || gender === null || gender === "") return "";
    const found = gendersReferential.find((g) => g.id == gender);
    return found ? found.name : "";
  },
  // Liste de civilités proposées à la SAISIE. Volontairement restreinte à
  // Monsieur / Madame : les autres civilités du référentiel restent gérées à
  // l'affichage (getGender/getFullName) mais ne sont pas offertes en sélection.
  // Les libellés sont repris du référentiel API quand il est disponible, avec un
  // fallback si les constantes ne sont pas encore chargées.
  getGendersInputList: (genders) => {
    const source =
      Array.isArray(genders) && genders.length ? genders : gendersReferential;
    const fromApi = source.filter((g) => g.id == 1 || g.id == 2);
    if (fromApi.length) return fromApi;
    return [
      { id: 1, name: "Monsieur" },
      { id: 2, name: "Madame" },
    ];
  },
  getFullName(user) {
    if (!user || Object.values(user).length === 0) return "inconnu";
    const genderLabel = tools.getGender(user.gender);
    const prefix = genderLabel ? genderLabel + " " : "";
    const firstname = tools.capitalize((user.firstname + "").toLowerCase()) || "";
    const lastname = tools.capitalize((user.lastname + "").toLowerCase()) || "";
    // Normalisation des espaces : évite tout espace parasite quand il n'y a pas
    // de préfixe (ex. code 0) et les doubles espaces produits par capitalize.
    return (prefix + firstname + " " + lastname).replace(/\s+/g, " ").trim();
  },
  capitalize: (s) => {
    if (typeof s !== "string") return "";
    let words = s.split(" ");
    let result = "";
    words.forEach((word) => {
      result += word.charAt(0).toUpperCase() + word.slice(1) + " ";
    });
    return result;
  },
  getFullNameAbbr(user) {
    return user
      ? tools.capitalize(user.firstname) +
          " " +
          user.lastname.toUpperCase()[0] +
          "."
      : "";
  },
  isOwner: (qualityOccupant) => {
    return qualityOccupant == 1 || qualityOccupant == 2;
  },
  calculateContentValue: (sumArray) => {
    return sumArray.reduce((a, b) => a + b);
  },
  round: (value) => {
    if (!value) return 0;
    return Math.round(parseFloat(value) * 100) / 100;
  },
  populateNamesFromId: (users, array = []) => {
    return array.map((t) => {
      let createdBy = tools.getFullNameAbbr(
        users.find((u) => u.id == t.createdBy)
      );
      let updatedBy = tools.getFullNameAbbr(
        users.find((u) => u.id == t.updatedBy)
      );
      return {
        ...t,
        id: t._id,
        createdBy,
        createdById: t.createdBy,
        updatedBy,
      };
    });
  },

  fallbackCopyTextToClipboard: (text) => {
    var textArea = document.createElement("textarea");
    textArea.value = text;

    // Avoid scrolling to bottom
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      var successful = document.execCommand("copy");
      var msg = successful ? "successful" : "unsuccessful";
      console.log("Fallback: Copying text command was " + msg);
    } catch (err) {
      console.error("Fallback: Oops, unable to copy", err);
    }

    document.body.removeChild(textArea);
  },
  copyTextToClipboard: (text) => {
    if (!navigator.clipboard) {
      tools.fallbackCopyTextToClipboard(text);
      return;
    }
    navigator.clipboard.writeText(text).then(
      function () {
        console.log("Async: Copying to clipboard was successful!");
      },
      function (err) {
        console.error("Async: Could not copy text: ", err);
      }
    );
  },
  getAffiliateLink: (affiliateCode, withUrl = "") => {
    return `${withUrl}?afcode=${affiliateCode}`;
  },
  getAmendmentReason: (detailsText) => {
    if (!detailsText) return "";
    const texts = detailsText.split("\n");
    if (texts.length > 1) {
      return texts[0];
    }
    return "";
  },
  validateEmail: (email) => {
    return email.match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
  },
  getDocumentName: ({
    fileExt,
    documentName,
    productName,
    companyName,
    uploadedAt,
  }) => {
    var filename = `${documentName}${productName ? "-" + productName : ""}${
      companyName ? "-" + companyName : ""
    }-${DateTime.fromISO(uploadedAt).toFormat("yyyy")}.${fileExt}`;

    return filename;
  },
  getEditDistance: (s, t) => {
    if (!s.length) return t.length;
    if (!t.length) return s.length;
    const arr = [];
    for (let i = 0; i <= t.length; i++) {
      arr[i] = [i];
      for (let j = 1; j <= s.length; j++) {
        arr[i][j] =
          i === 0
            ? j
            : Math.min(
                arr[i - 1][j] + 1,
                arr[i][j - 1] + 1,
                arr[i - 1][j - 1] + (s[j - 1] === t[i - 1] ? 0 : 1)
              );
      }
    }
    return arr[t.length][s.length];
  },
  calculateSimilarity: (str1, str2) => {
    if (!str1 || !str2) return 0;
    str1 = str1.toLowerCase();
    str2 = str2.toLowerCase();
    let longer = str1.length > str2.length ? str1 : str2;
    let shorter = str1.length <= str2.length ? str1 : str2;
    return (
      (longer.length - tools.getEditDistance(longer, shorter)) /
      parseFloat(longer.length)
    );
  },
  // Fonction pour trier les entreprises en fonction de la similarité avec le terme de recherche
  sortCompaniesByRelevance: (companies, searchTerm) => {
    return companies.sort(
      (a, b) =>
        tools.calculateSimilarity(b.company, searchTerm) -
        tools.calculateSimilarity(a.company, searchTerm)
    );
  },

  // Fonction pour trier les clients en fonction de la similarité du prénom/nom
  sortClientsByRelevance: (clients, nomPrenomSearch) => {
    return clients.sort((a, b) => {
      const similarityA = tools.calculateSimilarity(
        a.firstname + " " + a.lastname,
        nomPrenomSearch
      );
      const similarityB = tools.calculateSimilarity(
        a.firstname + " " + a.lastname,
        nomPrenomSearch
      );
      return similarityB - similarityA;
    });
  },

  // Fonction principale pour traiter et ordonner les résultats
  orderResults: (
    results,
    companySearch = "",
    firstnameSearch = "",
    lastnameSearch = ""
  ) => {
    // Si un terme de recherche pour le nom de société est fourni
    if (companySearch) {
      results.forEach((client) => {
        client.clients = tools.sortCompaniesByRelevance(
          client.clients,
          companySearch
        );
      });
    }

    // Si des termes de recherche pour le prénom/nom sont fournis
    if (firstnameSearch || lastnameSearch) {
      results = tools.sortClientsByRelevance(
        results,
        firstnameSearch,
        lastnameSearch
      );
    }

    return results;
  },
  getPlural: (count, singular, plural) => {
    return count > 1 ? plural : singular;
  },
};

export default tools;
